import { AlertTriangle, Send } from "lucide-react";

export function ChangeRequestConflictModal({
  open,
  error,
  isPending,
  confirmDisabled = false,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  error: string | null;
  isPending: boolean;
  confirmDisabled?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  if (!open) return null;

  return (
    <>
      <div
        data-testid="change-request-conflict-backdrop"
        onClick={() => {
          if (!isPending) onCancel();
        }}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)",
          zIndex: 400,
          backdropFilter: "blur(2px)",
        }}
      />
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 401,
          background: "var(--login-surface)",
          border: "1px solid var(--login-border)",
          borderRadius: "0.875rem",
          padding: "1.75rem",
          width: "min(92vw, 420px)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
          animation: "modalIn 0.2s ease both",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "0.875rem",
            marginBottom: "1rem",
          }}
        >
          <div
            style={{
              flexShrink: 0,
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "#9333ea18",
              border: "1px solid #9333ea40",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <AlertTriangle size={18} color="#9333ea" />
          </div>
          <div>
            <p
              style={{
                margin: 0,
                fontFamily: "'Barlow Condensed', sans-serif",
                fontWeight: 700,
                textTransform: "uppercase",
                fontSize: "1.125rem",
                letterSpacing: "0.04em",
                color: "var(--login-text)",
              }}
            >
              SOLICITAR ALTERAÇÃO?
            </p>
            <p
              style={{
                margin: "0.375rem 0 0",
                fontFamily: "'DM Sans', sans-serif",
                fontSize: "0.875rem",
                color: "var(--login-muted)",
                lineHeight: 1.5,
              }}
            >
              Este pedido já foi concluído. Deseja solicitar a adição deste
              item? A solicitação precisará ser aprovada pelo administrador.
            </p>
          </div>
        </div>

        {error && (
          <p
            style={{
              margin: "0 0 0.75rem",
              fontSize: "0.875rem",
              color: "#ef4444",
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            {error}
          </p>
        )}

        <div style={{ display: "flex", gap: "0.625rem", marginTop: "1.25rem" }}>
          <button
            onClick={onCancel}
            disabled={isPending}
            style={{
              flex: 1,
              padding: "0.75rem",
              background: "transparent",
              border: "1px solid var(--login-border)",
              borderRadius: "0.5rem",
              color: "var(--login-muted)",
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "0.9375rem",
              cursor: "pointer",
              opacity: isPending ? 0.5 : 1,
            }}
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            disabled={isPending || confirmDisabled}
            style={{
              flex: 2,
              padding: "0.75rem",
              background: "#9333ea",
              border: "none",
              borderRadius: "0.5rem",
              color: "#fff",
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 700,
              textTransform: "uppercase",
              fontSize: "0.9375rem",
              letterSpacing: "0.05em",
              cursor: isPending ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem",
              opacity: isPending ? 0.7 : 1,
            }}
          >
            <Send size={14} />
            {isPending ? "Enviando..." : "Solicitar alteração"}
          </button>
        </div>
      </div>
    </>
  );
}
